class ComparisonSizeSelect extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }

    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.attachListeners();
    }
  }

  disconnectedCallback() {
    if (!this.isConnected && this.initialized) {
      this.initialized = false;
      this.detachListeners();
    }
  }

  cacheElements() {
    this.openCloseHandler = this.openCloseHandler.bind(this);

    this.selector = this.querySelector('.ComparisonSizeSelect__Selector');
    this.menu = this.querySelector('.ComparisonSizeSelect__SizeMenu');
    this.sizeBtns = this.querySelectorAll('.ComparisonSizeSelect__SizeBtn');

    this.value = null;
    // Set the value to the first in the list.
    if (this.sizeBtns.length > 0) {
      this.setValuePassively(this.sizeBtns[0].dataset.value);
    }
  }

  attachListeners() {
    // Add open close handlers when clicking
    document.addEventListener('click', this.openCloseHandler);
  }

  detachListeners() {
    document.removeEventListener('click', this.openCloseHandler);
  }

  openCloseHandler(e) {
    if (this.contains(e.target)) {
      if (e.target.matches('.ComparisonSizeSelect__Selector')) {
        this.openMenu();
      } else if (e.target.matches('.ComparisonSizeSelect__SizeBtn')) {
        this.select(e.target);
      }
    } else {
      this.closeMenu();
    }
  }

  select(button) {
    this.updateSelfPassively(button);

    // Emit event
    this.dispatchEvent(
      new CustomEvent('size-select:changed', {
        detail: { value: this.value },
        bubbles: true,
      })
    );

    this.closeMenu();
  }

  /**
   * Does not emit any custom events.
   * Can be used to update its select passively in response to the variant
   * changing due to other components.
   */
  setValuePassively(value) {
    const button = this.querySelector(
      `.ComparisonSizeSelect__SizeBtn[data-value="${value}"]`
    );
    this.updateSelfPassively(button);
  }

  /**
   * Does not emit any custom events. Takes a button to update the select, which
   * is needed because the button has value and label info.
   */
  updateSelfPassively(button) {
    const index = Array.from(this.sizeBtns).indexOf(button);

    // Set new selected button
    this.sizeBtns.forEach((b) =>
      b.classList.remove('ComparisonSizeSelect__SizeBtn--selected')
    );
    button.classList.add('ComparisonSizeSelect__SizeBtn--selected');

    // Update selector
    this.selector.innerHTML = button.innerHTML;

    // Update inner state
    this.value = button.dataset.value;
  }

  openMenu() {
    this.menu.classList.remove('ComparisonSizeSelect__SizeMenu--hidden');
  }

  closeMenu() {
    this.menu.classList.add('ComparisonSizeSelect__SizeMenu--hidden');
  }
}
customElements.define('comparison-size-select', ComparisonSizeSelect);

/**
 * The 'Select Mattresses to Compare' buttons on the sticky nav. There are three
 * that reveal based on how many product columns were selected.
 */
class StickyCompSelectors {
  constructor(options = {}) {
    this.onClickSelector = options.onClickSelector;

    this.attachListeners();
  }

  /**
   * Add the click listener for the button that allows you to select a mattress.
   */
  attachListeners() {
    const showStickySelector = this.showStickySelector.bind(this);
    const selectProductHeaders = document.querySelectorAll(
      '.comparison-sticky-header__select'
    );
    selectProductHeaders.forEach((header) => {
      header.addEventListener('click', showStickySelector);
    });
  }

  showStickySelector() {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      1000
    );

    this.onClickSelector && this.onClickSelector();
  }

  /**
   * Updates which selectors should be visible.
   * @param isAdded Whether a product is being added or removed
   * @param positionIndex The flex order column position that was chosen
   */
  update(isAdded, positionIndex) {
    const selectBtns = document.querySelectorAll(
      '.comparison-sticky-header__select'
    );

    if (isAdded) {
      // Remove the select button at positionIndex
      const selectBtn = Array.from(selectBtns).find((btn) => {
        return btn.style.order === positionIndex.toString();
      });
      selectBtn.classList.add('hidden');
    } else {
      // Reveal a select button and give it the right flex order
      const selectBtn = Array.from(selectBtns).find((btn) => {
        return btn.classList.contains('hidden');
      });
      selectBtn.style.order = positionIndex;
      selectBtn.classList.remove('hidden');
    }
  }
}

/**
 * Sticky comparison header
 */
class StickyCompHeader {
  constructor(options = {}) {
    this.onSelectSize = options.onSelectSize;
    this.onClickSelector = options.onClickSelector;

    this.selectorManager = new StickyCompSelectors({
      onClickSelector: this.onClickSelector,
    });

    this.attachSizeChangeListener();
    this.addOnScroll();
  }

  attachSizeChangeListener() {
    // Capture size select changes
    const grid = document.querySelector('.comparison-sticky-header__container');
    grid.addEventListener('size-select:changed', (e) => {
      console.debug('size-select:changed', e.target, e.target.value);

      this.onSelectSize && this.onSelectSize(e.target);
    });
  }

  addOnScroll() {
    const navbar = document.querySelector('.comparison-sticky-header');
    window.addEventListener('scroll', () => {
      if (window.pageYOffset >= 80) {
        navbar.classList.add('sticky');
      } else {
        navbar.classList.remove('sticky');
      }
    });
  }

  /**
   * Update the selected products in the sticky header.
   */
  update(productId, isAdded, positionIndex) {
    const stickyItem = document.querySelector(
      `.comparison-sticky-header__item[data-product-id="${productId}"]`
    );

    if (isAdded) {
      stickyItem.classList.remove('hidden');
      stickyItem.style.display = 'block';
      stickyItem.style.order = positionIndex;
    } else {
      stickyItem.classList.add('hidden');
      stickyItem.style.display = 'none';
    }

    this.selectorManager.update(isAdded, positionIndex);
  }

  /**
   * Updates the column at 'index' without emitting any events.
   */
  updateColumnValue(index, value) {
    console.debug('sticky header: updateSelect', index, value);

    // Update the size select itself.
    const visibleBlocks = document.querySelectorAll(
      '.comparison-sticky-header__item:not(.hidden)'
    );
    const sizeSelect = visibleBlocks[index].querySelector(
      '.ComparisonSizeSelect'
    );
    sizeSelect.setValuePassively(value);
  }
}

/**
 * Holds and organizes product block columns.
 */
class CompProductBlockManager {
  constructor(options = {}) {
    this.onRemoveColumn = options.onRemoveColumn;
    this.onSelectSize = options.onSelectSize;

    this.attachListeners();
    this.initAllPriceBlocks();
  }

  attachListeners() {
    // Capture size select changes
    const grid = document.querySelector('.comparison-products__grid');
    grid.addEventListener('size-select:changed', (e) => {
      console.debug('size-select:changed', e.target, e.target.value);

      this.onSelectSize && this.onSelectSize(e.target);
    });

    // Listener to close entire product column
    const closeButtons = document.querySelectorAll('.comparison-close');
    closeButtons.forEach((cb) => {
      cb.addEventListener('click', () => {
        this.handleCloseBtnClick(cb);
      });
    });
  }

  handleCloseBtnClick(closeBtn) {
    const positionIndex = this.getPositionIndexOfCloseBtn(closeBtn);
    this.hideColumn(closeBtn.dataset.productId);
    this.onRemoveColumn &&
      this.onRemoveColumn(closeBtn.dataset.productId, positionIndex);
  }

  /**
   * Gets the index of the column that the given closeBtn is in.
   * If the column is not visible or doesn't exist it will return -1.
   */
  getPositionIndexOfCloseBtn(closeBtn) {
    const columnEl = closeBtn.closest('.comparison-product-block');
    return columnEl.style.order ? columnEl.style.order : '0';
  }

  hideColumn(productID) {
    const targetElement = document.querySelector(
      `.comparison-product-block[data-product-id="${productID}"]`
    );
    targetElement.classList.add('hidden');
    targetElement.dataset.selected = false;
  }

  showColumn(productID, positionIndex) {
    const newProduct = document.querySelector(
      `.comparison-product-block[data-product-id="${productID}"]`
    );
    newProduct.classList.remove('hidden');
    newProduct.dataset.selected = 'true';

    // Ensure it appears in the correct place
    newProduct.style.order = positionIndex;
  }

  /**
   * Updates the column at 'index' without emitting any events.
   */
  updateColumnValue(index, value) {
    console.debug('block manager: updateSelect', index, value);

    // Get the column
    const visibleBlocks = document.querySelectorAll(
      '.comparison-product-block[data-selected="true"]'
    );
    const column = visibleBlocks[index];

    // Update the size select itself.
    const sizeSelect = column.querySelector('.ComparisonSizeSelect');
    sizeSelect.setValuePassively(value);

    // Update the final price block.
    this.syncPriceBlock(column, value);
  }

  initAllPriceBlocks() {
    const columns = document.querySelectorAll(
      '.comparison-product-block[data-product-id]'
    );

    columns.forEach((col) => {
      this.syncPriceBlock(col);
    });
  }

  /**
   * Update the price block in the column, given a size value.
   * @param column
   * @param [sizeValue] The size value. If not given, then the first variant is chosen.
   */
  syncPriceBlock(column, sizeValue) {
    const productID = column.dataset.productId;
    const jsonData = JSON.parse(
      document.querySelector(
        `[data-product-json][data-product-id="${productID}"]`
      ).innerHTML
    );

    const todayPrice = column.querySelector('.CompPricesBlock__TodayPrice');
    const todayCompareAt = column.querySelector(
      '.CompPricesBlock__PayToday .StrikeLabel'
    );
    const savingsLabel = column.querySelector('.CompPricesBlock__SavingsLabel');
    const monthlyPrice = column.querySelector('.CompPricesBlock__MonthlyPrice');
    const learnMoreEl = column.querySelector(
      '.CompPricesBlock__PriceFooter--monthlyInfo'
    );

    let selectedVariant = jsonData.product.variants[0];
    if (sizeValue) {
      selectedVariant = jsonData.product.variants.find((v) =>
        v.options.includes(sizeValue)
      );
    }
    const totalPriceValue = selectedVariant.compare_at_price;
    const totalComparePriceValue = selectedVariant.price;

    todayPrice.innerHTML = NUtils.formatMoney(totalPriceValue);
    todayCompareAt.innerHTML = NUtils.formatMoney(totalComparePriceValue);

    const savingsAmt = totalComparePriceValue - totalPriceValue;
    if (savingsAmt > 0) {
      savingsLabel.innerHTML = `${NUtils.formatMoney(
        savingsAmt
      )} off with offer`;
    } else {
      savingsLabel.innerHTML = '';
    }

    monthlyPrice.dataset.amount = totalPriceValue;
    learnMoreEl.dataset.amount = totalPriceValue;
    window.AffirmEstimateLabels.initElementsWithExistingHTML(
      `.CompPricesBlock[data-product-id="${productID}"] .CompPricesBlock__MonthlyPrice`
    );
    window.AffirmEstimateLabels.initElWithoutEditingHTML(learnMoreEl);
  }
}

/**
 * Handles product selector grid items that have links to add products as a column.
 * Inside each selector grid item is a trigger element that opens a menu element
 * with add buttons inside.
 */
class CompProductSelectors {
  constructor(options = {}) {
    this.onAddColumn = options.onAddColumn;
    this.attachListeners();
  }

  attachListeners() {
    this.addOpenCloseSelectorListeners();
    this.addProductColumnListeners();
  }

  /**
   * Add click listeners to open and close mattress column selector.
   */
  addOpenCloseSelectorListeners() {
    // A large grid button with an svg and a label saying to select a mattress
    const selectProducts = document.querySelectorAll(
      '.comparison-products__selector'
    );

    // Show selector on click
    selectProducts.forEach((sp) => {
      sp.addEventListener('click', () => {
        sp.classList.add('hidden');
        sp.nextElementSibling.classList.remove('hidden');
      });
    });

    // Close button for selector
    const selectCloses = document.querySelectorAll(
      '.comparison-products__select-product-wrapper .close'
    );
    selectCloses.forEach((sc) => {
      sc.addEventListener('click', () => {
        const parentWrapper = sc.closest(
          '.comparison-products__select-product'
        );
        const trigger = parentWrapper.querySelector(
          '.comparison-products__selector'
        );
        const productMenu = parentWrapper.querySelector(
          '.comparison-products__select-product-wrapper'
        );
        trigger.classList.remove('hidden');
        productMenu.classList.add('hidden');
      });
    });
  }

  /**
   * Add a product column when the add links are clicked
   */
  addProductColumnListeners() {
    const addProductToCompare = document.querySelectorAll(
      '.comparison-products__item-case.add'
    );
    addProductToCompare.forEach((addButton) => {
      addButton.addEventListener('click', () => {
        // Get the position index so we know which column was clicked in.
        const positionIndex = this.getPositionIndexOfAddBtn(addButton);

        this.hideParentSelector(addButton);
        this.onAddColumn &&
          this.onAddColumn(addButton.dataset.productId, positionIndex);
        this.updateSelectedProductList(addButton.dataset.productId, true);
      });
    });
  }

  /**
   * Gets the index of the column that the given addButton is in.
   * If the column is not visible or doesn't exist it will return -1.
   */
  getPositionIndexOfAddBtn(addButton) {
    const columnEl = addButton.closest('.comparison-product-block');
    return columnEl.style.order ? columnEl.style.order : '0';
  }

  openVisibleSelectors() {
    const productSelectors = document.querySelectorAll(
      '.comparison-products__select-product'
    );
    productSelectors.forEach((ps) => {
      if (!ps.classList.contains('hidden')) {
        ps.querySelector('.comparison-products__selector').classList.add(
          'hidden'
        );
        ps.querySelector(
          '.comparison-products__select-product-wrapper'
        ).classList.remove('hidden');
      }
    });
  }

  /**
   * Updates list of "Add to compare" buttons in the selector.
   */
  updateSelectedProductList(productId, isAdded) {
    const notSelectedProductItems = document.querySelectorAll(
      `.comparison-products__item-case.add[data-product-id="${productId}"]`
    );
    const selectedProductItems = document.querySelectorAll(
      `.comparison-products__item-case.added[data-product-id="${productId}"]`
    );

    if (isAdded) {
      selectedProductItems.forEach((el) => {
        el.classList.remove('hidden');
      });
      notSelectedProductItems.forEach((el) => {
        el.classList.add('hidden');
      });
    } else {
      selectedProductItems.forEach((el) => {
        el.classList.add('hidden');
      });
      notSelectedProductItems.forEach((el) => {
        el.classList.remove('hidden');
      });
    }
  }

  /**
   * Hides the selector grid item that is the parent of the given addButton.
   */
  hideParentSelector(addButton) {
    // Select the parent selector grid item
    const selectorBlock = addButton.closest('.comparison-product-block');

    // Selector with svg and label
    const trigger = selectorBlock.querySelector(
      '.comparison-products__selector'
    );

    // Element with all the add buttons inside
    const menu = selectorBlock.querySelector(
      '.comparison-products__select-product-wrapper'
    );

    // Hide all three elements
    selectorBlock.classList.add('hidden');
    trigger.classList.add('hidden');
    menu.classList.add('hidden');
  }

  /**
   * Reveals one hidden selector.
   */
  revealOneSelector(positionIndex) {
    const oneHiddenSelector = document.querySelector(
      '.comparison-products__select-product.hidden'
    );
    oneHiddenSelector.classList.remove('hidden');
    const trigger = oneHiddenSelector.querySelector(
      '.comparison-products__selector'
    );
    trigger.classList.remove('hidden');

    // Ensure it appears in the right column
    oneHiddenSelector.style.order = positionIndex;
  }
}
class CompProductGrid {
  constructor() {
    this.stickyHeader = new StickyCompHeader({
      onSelectSize: this.onSelectSize.bind(this),
      onClickSelector: this.onClickStickySelector.bind(this),
    });

    // The menus that lets you choose to add product columns.
    // There are three selectors since you can remove all three product columns
    this.productSelectors = new CompProductSelectors({
      onAddColumn: this.onAddColumn.bind(this),
    });

    // Manager that initializes and handles the product blocks (a column).
    this.productBlockManager = new CompProductBlockManager({
      onRemoveColumn: this.onRemoveColumn.bind(this),
      onSelectSize: this.onSelectSize.bind(this),
    });

    this.cacheElements();
    this.initFlexOrders();
    this.initSwiperContainers();
    this.addNormalizeHeightListener();
    this.normalizeAllHeights();

    // On mobile, close the second column immediately
    if (window.innerWidth <= 1024) {
      const colCloseBtns = document.querySelectorAll(
        '.comparison-product-block:not(.hidden) .comparison-close'
      );
      if (colCloseBtns[1]) {
        this.productBlockManager.handleCloseBtnClick(colCloseBtns[1]);
      }
    }

    // Normalize heights again in the event fonts and images load slowly
    window.addEventListener('load', this.normalizeAllHeights.bind(this));
  }

  cacheElements() {
    // Cache needed elements, starting with the first product column.
    this.firstProductCol = document.querySelector(
      '.comparison-product-block[data-selected]'
    );

    // Get all column items
    this.allColumnItems = document.querySelectorAll(
      '.comparison-product-block__item'
    );

    // A nodelists of the first column's items. Items in this case refers to
    // a grid item in a column such as "Best For", "Feel", "Overview" and so on.
    this.firstColumnItems = this.firstProductCol.querySelectorAll(
      '.comparison-product-block__item'
    );
  }

  initFlexOrders() {
    const visibleColItems = document.querySelectorAll(
      '.comparison-product-block:not(.hidden)'
    );
    visibleColItems.forEach((col, index) => {
      col.style.order = index;
    });
    const stickyColItems = document.querySelectorAll(
      '.comparison-sticky-header__item:not(.hidden)'
    );
    stickyColItems.forEach((col, index) => {
      col.style.order = index;
    });
  }

  initSwiperContainers() {
    this.reviewSwipers = new Swiper(
      '.comparison-product-review.swiper-container',
      {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: '.comparison-product-review__Nav .swiper-button-next',
          prevEl: '.comparison-product-review__Nav .swiper-button-prev',
        },
        pagination: {
          el: '.comparison-product-review__pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    );

    this.overviewSwipers = new Swiper(
      '.overview-item__certificate.swiper-container',
      {
        slidesPerView: 1,
        loop: false,
        navigation: {
          nextEl: '.overview-item__certificate-Nav .swiper-button-next',
          prevEl: '.overview-item__certificate-Nav .swiper-button-prev',
        },
        pagination: {
          el: '.overview-item__certificate-pagination',
          type: 'bullets',
          clickable: true,
        },
      }
    );
  }

  updateSwipers() {
    this.reviewSwipers.forEach((s) => s.update());
    this.overviewSwipers.forEach((s) => s.update());
  }

  /**
   * Passed to the click listener of the buttons in CompProductSelectors.
   * Shows the correct product column and updates the sticky header.
   */
  onAddColumn(productID, positionIndex) {
    this.productBlockManager.showColumn(productID, positionIndex);
    this.stickyHeader.update(productID, true, positionIndex);
    this.updateSwipers();
    this.normalizeAllHeights();
  }

  /**
   * Passed to the click listener of the product blocks' close button.
   * Updates the sticky header and product selectors.
   */
  onRemoveColumn(productID, positionIndex) {
    this.stickyHeader.update(productID, false, positionIndex);
    this.productSelectors.updateSelectedProductList(productID, false);

    // Reveal a product menu now to take place of the column that was just removed.
    this.productSelectors.revealOneSelector(positionIndex);

    this.updateSwipers();
    this.normalizeAllHeights();
  }

  onSelectSize(sizeSelect) {
    const columnIndex = this.getColumnIndexOfSelect(sizeSelect);

    if (columnIndex >= 0) {
      this.stickyHeader.updateColumnValue(columnIndex, sizeSelect.value);
      this.productBlockManager.updateColumnValue(columnIndex, sizeSelect.value);
    }
  }

  /**
   * Passed to the click listener of the open product menu button in the sticky
   * header. We open the visible selectors because the sticky menu button only
   * scrolls the window up and doesn't have a menu of its own.
   */
  onClickStickySelector() {
    this.productSelectors.openVisibleSelectors();
  }

  /**
   * Given a SizeSelect element, find the index of the column its in.
   * A size select will either be in the sticky header or the product column.
   * This is not the visible index but the index in the DOM (because visibly it
   * could be different since we're using flex order).
   */
  getColumnIndexOfSelect(sizeSelect) {
    let parentBlock, visibleBlocks;

    // If the size select is in the sticky header, get its parent so we can
    // prepare to count its index position.
    if (
      sizeSelect.classList.contains('comparison-sticky-header__size-select')
    ) {
      parentBlock = sizeSelect.closest('.comparison-sticky-header__item');
      visibleBlocks = document.querySelectorAll(
        '.comparison-sticky-header__item:not(.hidden)'
      );

      // Otherwise, its in the product block, so get the wrapping parent block to
      // figure out what column index its in.
    } else {
      parentBlock = sizeSelect.closest('.comparison-product-block');
      visibleBlocks = document.querySelectorAll(
        '.comparison-product-block[data-selected="true"]'
      );
    }

    // Get the index of the column its in by looking at visible siblings.
    const index = Array.from(visibleBlocks).findIndex((b) => {
      return b === parentBlock;
    });
    return index;
  }

  addNormalizeHeightListener() {
    window.addEventListener(
      'resize',
      NUtils.debounce(this.normalizeAllHeights.bind(this), 200)
    );
  }

  normalizeAllHeights() {
    // Reset heights
    this.unNormalizeAllHeights();

    // Go one item at a time and normalize all their heights to each other.
    this.firstColumnItems.forEach((item) => {
      const itemName = item.dataset.itemName;
      const allItemsInRow = document.querySelectorAll(
        `.comparison-product-block__item[data-item-name="${itemName}"]`
      );
      this.normalizeHeights(allItemsInRow);
    });
  }

  normalizeHeights(elements) {
    // Then recalculate and set
    let largestHeight = 0;
    elements.forEach((el) => {
      const height = el.offsetHeight;
      if (height > largestHeight) {
        largestHeight = height;
      }
    });
    elements.forEach((el) => {
      el.style.height = largestHeight + 'px';
    });
  }

  unNormalizeAllHeights() {
    this.allColumnItems.forEach((item) => {
      item.style.height = 'auto';
    });
  }
}

/**
 * The popup that opens when the little (i) is pressed in the ribbon on top.
 */
class ColumnInfoPopups {
  constructor() {
    const gridEl = document.querySelector('.comparison-products__grid');
    this.popupTriggers = gridEl.querySelectorAll('[data-open-prod-info-popup]');
    this.attachListeners();
  }

  attachListeners() {
    this.popupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const handle = trigger.dataset.openProdInfoPopup;
        const popupContents = document.querySelector(
          `[data-prod-info-popup-contents="${handle}"]`
        );
        const htmlContents = popupContents.innerHTML;
        window.GlobalNPopup.openWithContents(
          'product-card-addon',
          htmlContents
        );
      });
    });
  }
}

class ComparisonPage {
  constructor() {
    // Initialize popup triggers
    new ColumnInfoPopups();

    // Initialize the grid
    new CompProductGrid();
  }
}

new ComparisonPage();
